/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const BannerListPage = lazyLoad(
  () => import('./index'),
  module => module.BannerListPage
);
